/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Products } from '../../models/products';

export interface TenantsTenantIdCatalogEntriesProductsGet$Params {
  tenantId: string;
  includeDeleted?: boolean;
  includePlu?: boolean;
  size?: string;
  start?: string;
}

export function tenantsTenantIdCatalogEntriesProductsGet(http: HttpClient, rootUrl: string, params: TenantsTenantIdCatalogEntriesProductsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Products>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdCatalogEntriesProductsGet.PATH, 'get');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.query('includeDeleted', params.includeDeleted, {});
    rb.query('includePlu', params.includePlu, {});
    rb.query('size', params.size, {});
    rb.query('start', params.start, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Products>;
    })
  );
}

tenantsTenantIdCatalogEntriesProductsGet.PATH = '/tenants/{tenantId}/catalog-entries/products';
